export const state = () => {
	return {
		brandingProfil: {},
		ttl_branding: null,
		cache_duration_branding: 3600000, // 1 hour
		cache_key_branding: '',
	}
}

function isInCacheBranding(state, companyId) {
	if (state.cache_key_branding !== buildCacheKeyBranding(companyId)) {
		return false
	}
	if (state.ttl_branding === null || state.ttl_branding < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyBranding(companyId) {
	return `company:${companyId}:branding-profil`
}

export const actions = {
	async retrieve({ state, commit }, { companyId }) {
		if (isInCacheBranding(state, companyId)) {
			return state.brandingProfil
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/branding-profil/`)
			.then((res) => {
				commit('setBranding', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('clearCacheBranding')
				throw err
			})
	},

	async partialUpdate({ state, commit }, { companyId, id, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/branding-profil/${id}/`, {
				method: 'PATCH',
				body: data,
			})
			.then((res) => {
				commit('setBranding', { data: res, companyId })
				commit('clearCacheBranding')
			})
			.catch((err) => {
				commit('clearCacheBranding')
				throw err
			})
	},
}

export const mutations = {
	setBranding(state, { data, companyId }) {
		state.brandingProfil = data
		state.ttl_branding = Date.now() + state.cache_duration_branding
		state.cache_key_branding = buildCacheKeyBranding(companyId)
	},

	clearCacheBranding(state) {
		state.ttl_branding = null
	},
}
